/* eslint-disable jsx-a11y/label-has-for */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Clickable from '../Clickable';
import Icon from '../Icon';
import s from './Radio.scss';
import { openInNewTabProp } from '../../constants';

class Radio extends PureComponent {
  static propTypes = {
    label: PropTypes.node,
    disabled: PropTypes.bool,
    hint: PropTypes.string,
    className: PropTypes.string,
    isSelected: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    icon: PropTypes.string,
    hasError: PropTypes.bool,
    showLabel: PropTypes.bool,
    blockBtn: PropTypes.bool,
    link: PropTypes.shape(),
    image: PropTypes.shape(),
    subLabel: PropTypes.string,
    children: PropTypes.node,
    iconSize: PropTypes.number,
  };

  static defaultProps = {
    label: undefined,
    disabled: false,
    hint: undefined,
    isSelected: false,
    className: null,
    icon: undefined,
    hasError: false,
    showLabel: false,
    blockBtn: false,
    iconSize: undefined,
    link: {
      label: undefined,
      href: undefined,
    },
    image: {
      src: undefined,
      alt: undefined,
    },
    subLabel: undefined,
    children: null,
  };

  render() {
    const {
      label,
      value,
      hint,
      disabled,
      isSelected,
      className,
      onChange,
      icon,
      hasError,
      showLabel,
      blockBtn,
      link,
      image,
      subLabel,
      children,
      iconSize,
      ...props
    } = this.props;
    const classes = cx(
      s.root,
      disabled && s.disabled,
      isSelected && s.selected,
      hint && s.hasHint,
      blockBtn && s.blockBtn,
      link.label && link.href && s.hasLink,
      image && image.alt && image.src && s.hasImg,
      className,
    );

    return (
      <label className={classes} {...props}>
        <input
          onChange={onChange}
          type="radio"
          value={value}
          checked={isSelected}
          disabled={disabled}
          className="visually-hidden"
        />
        <span className={s.label}>{label}</span>
        {subLabel && <span className={s.subLabel}>{subLabel}</span>}
        {icon && <Icon name={icon} className={s.icon} size={iconSize} />}
        {hint && <span className={s.hint}>{hint}</span>}
        {link && link.label && link.href && (
          <Clickable
            tag="a"
            href={link.href}
            label={link.label}
            className={s.link}
            target={openInNewTabProp}
            rel="noopener noreferrer nofollow"
          />
        )}
        {image && image.alt && image.src && (
          <img src={image.src} alt={image.alt} className={s.img} />
        )}

        {children && <div className={s.children}>{children}</div>}
      </label>
    );
  }
}

export default withStyles(s)(Radio);
